import { Checkbox as ChakraCheckbox, CheckboxProps } from '@chakra-ui/react';
import React, { FC } from 'react';

export const Checkbox: FC<CheckboxProps> = ({ ...props }) => {
  return <ChakraCheckbox fontFamily="Helvetica Neue" fontSize="xs" {...props}></ChakraCheckbox>;
};
